import {gateway} from '../../api';

const CORREIOS = process.env.REACT_APP_CORREIOS;

export const getCorreiosCep = cep => (
  gateway.get(`${CORREIOS}/cep/${cep}`)
);
